const Message = () => {
  return (
    <div>
      <h1 className="h-[70vh] mx-auto flex items-center justify-center font-medium text-2xl">Coming Soon!</h1>
    </div>
  );
};

export default Message;